import { Loader } from "@/components/formation";
import styles from "./loadingBackdrop.module.scss";

type LoadingBackdropProps = {
  loading: boolean;
};

const LoadingBackdrop = ({ loading }: LoadingBackdropProps) => {
  if (loading) {
    return (
      <div className={styles.loadingContainer} data-testid="loading-backdrop">
        <Loader />
      </div>
    );
  }

  return null;
};

export default LoadingBackdrop;
